import Vue from 'vue'
import Vuex from 'vuex'
//import vuescroll from 'vuescroll';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLazyLoad from 'vue-lazyload'
import VueI18n from 'vue-i18n'
import interceptorsSetup from './interceptors'
import VueMoment from 'vue-moment';
import * as VueGoogleMaps from 'gmap-vue'
import Autocomplete from 'v-autocomplete'

import messages from './locales/lang.json';

import { VueHammer } from 'vue2-hammer'

Vue.use(VueHammer)

//import 'viewerjs/dist/viewer.css'
//import VueViewer from 'v-viewer'

//Vue.use(VueViewer)

Vue.use(Autocomplete)
Vue.config.productionTip = false
Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages
});




Vue.use(VueMoment);

Vue.component('forum-search', require('./components/forum/forum-search.vue').default);

Vue.component('chatcomponent', require('./components/discuss/prac/ChatComponent.vue').default);
Vue.component('optionspopup', require('./components/discuss/prac/OptionsPopup.vue').default);

Vue.component('options-popup', require('./components/discuss/options-popup.vue').default);
Vue.component('card-child-document', require('./components/document/card-child-document.vue').default);
Vue.component('card-document', require('./components/document/card-document.vue').default);

Vue.component('card-list', require('./components/cards/card-list.vue').default);
Vue.component('card-list-new', require('./components/cards/card-list-new.vue').default);


Vue.component('custom-lightbox', require('./components/lightbox/custom-lightbox.vue').default);
Vue.component('activator', require('./components/activator/activator.vue').default);

Vue.component('o-embed-2', require('./components/oembed/oembed.vue').default);

/*Vue.component('simple.join-bar', require('./components/join/simple-join-bar.vue').default);*/

Vue.component('simple-carousel', require('./components/carousel/simple-carousel.vue').default);

Vue.component('assign-schedule', require('./components/calander/assign-schedule.vue').default);
Vue.component('full-calander', require('./components/calander/full-calander.vue').default);
Vue.component('import-calander-holidays', require('./components/calander/import-calander-holidays.vue').default);

Vue.component('manage-location-shifts', require('./components/shift/manage-location-shifts.vue').default);
Vue.component('location-shift', require('./components/shift/location-shift.vue').default);
Vue.component('location-shift-new', require('./components/shift/location-shift-new.vue').default)
Vue.component('team-scheduling', require('./components/shift/team-scheduling.vue').default)
Vue.component('add-shift', require('./components/shift/add-shift.vue').default);
Vue.component('shift-select-selector', require('./components/shift/shift-select-selector.vue').default);
Vue.component('location-shifts-time', require('./components/shift/location-shifts-time.vue').default);
Vue.component('manage-shift-procedures', require('./components/shift/manage-shift-procedures.vue').default);
Vue.component('shift-personel', require('./components/shift/shift-personel.vue').default);
Vue.component('location-shifts-edit', require('./components/shift/location-shift-edit.vue').default);

Vue.component('forgot-password', require('./components/login/forgot-password.vue').default);
Vue.component('login-default', require('./components/login/login-default.vue').default);
Vue.component('login-with-tmp-email', require('./components/login/login-with-tmp-email.vue').default);
Vue.component('user-activate', require('./components/login/user-activate.vue').default);
Vue.component('login-select-site', require('./components/login/login-select-site.vue').default);
Vue.component('select-site', require('./components/login/select-site.vue').default);

Vue.component('register-simple', require('./components/register/register-simple.vue').default);

//
Vue.component('button-read-this', require('./components/discuss/button-read-this.vue').default);

Vue.component('discussion-notification-icon', require('./components/discuss/discussion-notification-icon.vue').default);
Vue.component('discuss-menu', require('./components/discuss/discuss-menu.vue').default);
Vue.component('discuss-miniview', require('./components/discuss/discuss-miniview.vue').default);
Vue.component('discuss-singlethread', require('./components/discuss/discuss-singlethread.vue').default);
Vue.component('discuss-singlethread-miniview', require('./components/discuss/discuss-singlethread-miniview.vue').default);

Vue.component('discuss-recursive-message', require('./components/discuss/discuss-recursive-message.vue').default);

Vue.component('item-template', require('./components/procedure/item-template.vue').default);
Vue.component('procedureschedule-tag', require('./components/procedure/procedureschedule-tag.vue').default);

Vue.component('procedure-page-selector', require('./components/procedure/procedure-page-selector').default);
Vue.component('procedure-pager', require('./components/procedure/procedure-pager').default);


Vue.component('procedure-editmenu', require('./components/procedure/procedure-editmenu').default);
Vue.component('procedure-quicklink-menu', require('./components/procedure/procedure-quicklink-menu').default);

Vue.component('procedure-done-reject', require('./components/procedure/procedure-done-reject').default);
Vue.component('procedure-new-done-reject', require('./components/procedure/procedure-new-done-reject').default);

Vue.component('procedure-quicksave', require('./components/procedure/procedure-quicksave').default);

Vue.component('procedure-details', require('./components/procedure/procedure-details.vue').default);
Vue.component('procedure-editmode', require('./components/procedure/procedure-editmode.vue').default);
Vue.component('procedure-workmode', require('./components/procedure/procedure-workmode.vue').default);
Vue.component('procedure-historymode', require('./components/procedure/procedure-historymode.vue').default);
Vue.component('procedure-sch-historymode', require('./components/procedure/procedure-sch-historymode.vue').default);
Vue.component('procedure-materialmode', require('./components/procedure/procedure-materialmode.vue').default);
Vue.component('procedure-timespentmode', require('./components/procedure/procedure-timespentmode.vue').default);
Vue.component('procedure-assign', require('./components/procedure/procedure-assign.vue').default);
Vue.component('procedure-save', require('./components/procedure/procedure-save.vue').default);
Vue.component('procedure-name', require('./components/procedure/procedure-name.vue').default);
Vue.component('procedure-expand', require('./components/procedure/procedure-expand.vue').default);
Vue.component('procedure-view-expand', require('./components/procedure/procedure-view-expand.vue').default);
Vue.component('procedure-advanced-settings', require('./components/procedure/procedure-advanced-settings.vue').default);
Vue.component('procedure-property-settings', require('./components/procedure/procedure-property-settings.vue').default);
Vue.component('procedureschedule-settings', require('./components/procedure/procedureschedule-settings.vue').default);
Vue.component('procedure-selector', require('./components/procedure/procedure-selector.vue').default);
Vue.component('procedure-selector-with-add', require('./components/procedure/procedure-selector-with-add.vue').default);
Vue.component('procedure-or-category-selector-with-add', require('./components/procedure/procedure-or-category-selector-with-add.vue').default);

//
/*Vue.component('procedure-and-category-and-tag-selector', require('./components/procedure/procedure-and-category-and-tag-selector.vue').default);*/
Vue.component('category-and-tag-selector', require('./components/procedure/category-and-tag-selector.vue').default);
Vue.component('procedure-schedule', require('./components/procedure/procedure-schedule.vue').default);
Vue.component('procedure-export-import', require('./components/procedure/procedure-export-import.vue').default);
Vue.component('site-permission', require('./components/procedure/site-permission.vue').default);
//Vue.component('nested-draggable', require('./components/procedure/nested-draggable.vue').default);
Vue.component('nested-property', require('./components/procedure/nested-property.vue').default);
Vue.component('nested-viewproperty', require('./components/procedure/nested-viewproperty.vue').default);

Vue.component('element-view-slider', require('./components/procedure/procedure-viewing-elements/element-view-slider.vue').default);
Vue.component('element-view-camera', require('./components/procedure/procedure-viewing-elements/element-view-camera.vue').default);

Vue.component('element-view-page', require('./components/procedure/procedure-viewing-elements/element-view-page.vue').default);
Vue.component('element-view-page-ending', require('./components/procedure/procedure-viewing-elements/element-view-page-ending.vue').default);
Vue.component('element-view-slideshow', require('./components/procedure/procedure-viewing-elements/element-view-slideshow.vue').default);
Vue.component('element-view-booking', require('./components/procedure/procedure-viewing-elements/element-view-booking.vue').default);


Vue.component('element-selector', require('./components/procedure/procedure-editor-elements/element-selector.vue').default);

Vue.component('element-camera', require('./components/procedure/procedure-editor-elements/element-camera.vue').default);

Vue.component('element-controls', require('./components/procedure/procedure-editor-elements/element-controls.vue').default);

Vue.component('element-text', require('./components/procedure/procedure-editor-elements/element-text.vue').default);
Vue.component('element-title', require('./components/procedure/procedure-editor-elements/element-title.vue').default);
Vue.component('element-html-editor', require('./components/procedure/procedure-editor-elements/element-html-editor.vue').default);
Vue.component('element-hidden', require('./components/procedure/procedure-editor-elements/element-hidden.vue').default);
Vue.component('element-select', require('./components/procedure/procedure-editor-elements/element-select.vue').default);

Vue.component('element-page', require('./components/procedure/procedure-editor-elements/element-page.vue').default);
Vue.component('element-page-ending', require('./components/procedure/procedure-editor-elements/element-page-ending.vue').default);
Vue.component('element-button', require('./components/procedure/procedure-editor-elements/element-button.vue').default);
Vue.component('element-slideshow', require('./components/procedure/procedure-editor-elements/element-slideshow.vue').default);

Vue.component('element-qrcode', require('./components/procedure/procedure-editor-elements/element-qrcode.vue').default);
Vue.component('element-checkbox', require('./components/procedure/procedure-editor-elements/element-checkbox.vue').default);
Vue.component('element-image', require('./components/procedure/procedure-editor-elements/element-image.vue').default);
Vue.component('element-upload', require('./components/procedure/procedure-editor-elements/element-upload.vue').default);
Vue.component('element-textfield', require('./components/procedure/procedure-editor-elements/element-textfield.vue').default);
Vue.component('element-textarea', require('./components/procedure/procedure-editor-elements/element-textarea.vue').default);
Vue.component('element-worknote', require('./components/procedure/procedure-editor-elements/element-worknote.vue').default);
Vue.component('element-booking', require('./components/procedure/procedure-editor-elements/element-booking.vue').default);

Vue.component('draggable-menu', require('./components/procedure/draggable-menu.vue').default);






/*Vue.component('generic-menu', require('./components/menues/generic-menu.vue').default);*/
Vue.component('nested-menu', require('./components/menues/nested-menu.vue').default);
Vue.component('nested-draggable-menu', require('./components/menues/nested-draggable-menu.vue').default);

Vue.component('category-file-selector', require('./components/upload/category-file-selector.vue').default);
Vue.component('file-selector', require('./components/upload/file-selector.vue').default);

Vue.component('upload-button-camera', require('./components/upload/upload-button-camera.vue').default);
Vue.component('upload-button-camera-noaction', require('./components/upload/upload-button-camera-noaction.vue').default);


Vue.component('upload-button', require('./components/upload/upload-button.vue').default);
Vue.component('upload-files', require('./components/upload/upload-files.vue').default);
Vue.component('upload-file-selector', require('./components/upload/upload-file-selector.vue').default);
Vue.component('upload-file-selector2', require('./components/upload/upload-file-selector2.vue').default);
Vue.component('upload-container', require('./components/upload/upload-container.vue').default);

Vue.component('upload-file-lib', require('./components/upload/upload-file-lib.vue').default);
Vue.component('upload-file-properties', require('./components/upload/upload-file-properties.vue').default);

Vue.component('mce-editor', require('./components/mce/mce-editor.vue').default);
Vue.component('new-mce-editor', require('./components/mce/new-mce-editor.vue').default);

Vue.component('html-templates', require('./components/mce/html-templates.vue').default);

Vue.component('modal-in-front', require('./components/modals/modal-in-front.vue').default);
Vue.component('modal-empty', require('./components/modals/modal-empty.vue').default);
Vue.component('modal-default', require('./components/modals/modal-default.vue').default);
Vue.component('modal-no-ref', require('./components/modals/modal-no-ref.vue').default);
Vue.component('modal-three-buttons', require('./components/modals/modal-three-buttons.vue').default);
Vue.component('modal-single-button', require('./components/modals/modal-single-button.vue').default);

Vue.component('static-height-container', require('./components/containers/static-height-container').default);

Vue.component('vertical-tabs', require('./components/containers/vertical-tabs').default);
Vue.component('container-card', require('./components/containers/container-card').default);
Vue.component('container-expand-left', require('./components/containers/container-expand-left').default);
Vue.component('container-expand-right', require('./components/containers/container-expand-right').default);
Vue.component('large-container-expand-right', require('./components/containers/large-container-expand-right').default);

Vue.component('panels', require('./components/containers/panels').default);

Vue.component('common-ticker', require('./components/common/common-ticker').default);
Vue.component('common-round-image', require('./components/common/common-round-image').default);


Vue.component('viewmaker-tableview', require('./components/viewmaker/viewmaker-tableview').default);
Vue.component('viewmaker-container', require('./components/viewmaker/viewmaker-container').default);
Vue.component('viewmaker-tabs', require('./components/viewmaker/viewmaker-tabs').default);
Vue.component('viewmaker-date-selector', require('./components/viewmaker/viewmaker-date-selector').default);



Vue.component('input-camera', require('./components/form-components/input-camera').default);

Vue.component('input-color-selector', require('./components/form-components/input-color-selector').default);

Vue.component('input-select3', require('./components/form-components/input-select3').default);
Vue.component('input-select4', require('./components/form-components/input-select4').default);

Vue.component('input-date-navigation', require('./components/form-components/input-date-navigation').default);

Vue.component('input-inline-date', require('./components/form-components/input-inline-date').default);
Vue.component('input-inline-daterange', require('./components/form-components/input-inline-daterange').default);

Vue.component('input-inline-calender', require('./components/form-components/input-inline-calender').default);
Vue.component('input-inline-calender-and-dates', require('./components/form-components/input-inline-calender-and-dates').default);

Vue.component('input-month-selector', require('./components/form-components/input-month-selector').default);
Vue.component('input-select', require('./components/form-components/input-select').default);
Vue.component('input-checkbox', require('./components/form-components/input-checkbox').default);
Vue.component('input-radio', require('./components/form-components/input-radio').default);
Vue.component('input-text', require('./components/form-components/input-text').default);
Vue.component('input-textarea', require('./components/form-components/input-textarea').default);
Vue.component('input-slider', require('./components/form-components/input-slider').default);

Vue.component('startpage-container', require('./components/startpage/startpage-container').default);
/*Vue.component('mytasks', require('./components/startpage/mytasks').default);*/
Vue.component('startpage-editor-container', require('./components/startpage/startpage-editor-container').default);
Vue.component('importantdates-editor', require('./components/startpage/importantdates-editor').default);
Vue.component('news-editor', require('./components/startpage/news-editor').default);
Vue.component('cover-editor', require('./components/startpage/cover-editor').default);

//


//buttons
Vue.component('ok-button', require('./components/form-components/buttons/ok-button').default);
Vue.component('cancel-button', require('./components/form-components/buttons/cancel-button').default);
Vue.component('warning-button', require('./components/form-components/buttons/warning-button').default);
Vue.component('danger-button', require('./components/form-components/buttons/danger-button').default);

/*Vue.component('input-styleselector', require('./components/form-components/input-styleselector').default);*/

Vue.component('contact-selector', require('./components/contact/contact-selector').default);
Vue.component('team-selector', require('./components/team/team-selector').default);
Vue.component('add-teammember-selector', require('./components/team/add-teammember-selector').default);
Vue.component('location-selector', require('./components/location/location-selector').default);
Vue.component('team-select-selector', require('./components/team/team-select-selector').default);
Vue.component('team-registration-invite', require('./components/team/team-registration-invite').default);
Vue.component('team-registration-invite-new', require('./components/team/team-registration-invite-new').default);
//
Vue.component('priority-selector', require('./components/priority/priority-selector').default);
Vue.component('status-selector', require('./components/status/status-selector').default);

Vue.component('manage-team', require('./components/team/manage-team').default);


//Vue.component('layout', require('./components/layout/layout').default);
//Vue.component('layout-left', require('./components/layout/layout-left').default);
//Vue.component('layout-main', require('./components/layout/layout-main').default);
//Vue.component('layout-right', require('./components/layout/layout-right').default);

Vue.component('basic-table', require('./components/tables/basic-table').default);
Vue.component('addable-table', require('./components/tables/addable-table').default);

Vue.component('table-pagination', require('./components/tables/table-pagination').default);

Vue.component('filter-team-users', require('./components/filter/filter-team-users').default);
Vue.component('filter-container-small', require('./components/filter/filter-container-small').default);
Vue.component('filter-container-mini', require('./components/filter/filter-container-mini').default);
Vue.component('mycalander-filter', require('./components/filter/mycalander-filter').default);
Vue.component('filter-container', require('./components/filter/filter-container').default);
Vue.component('filter-button', require('./components/filter/filter-button').default);
/*Vue.component('filter-button-small', require('./components/filter/filter-button-small').default);*/
Vue.component('filter-procedure', require('./components/filter/filter-procedure').default);


Vue.component('config-priority', require('./components/filter/configurators/config-priority').default);
Vue.component('config-user', require('./components/filter/configurators/config-user').default);
Vue.component('config-contact', require('./components/filter/configurators/config-contact').default);
Vue.component('config-team', require('./components/filter/configurators/config-team').default);
Vue.component('config-location', require('./components/filter/configurators/config-location').default);
Vue.component('config-date', require('./components/filter/configurators/config-date').default);
Vue.component('config-organisation', require('./components/filter/configurators/config-organisation').default);

Vue.component('display-priority', require('./components/filter/displayers/display-priority').default);
Vue.component('display-user', require('./components/filter/displayers/display-user').default);
Vue.component('display-user-taskstatus', require('./components/filter/displayers/display-user-taskstatus').default);
Vue.component('display-user-time', require('./components/filter/displayers/display-user-time').default);

Vue.component('display-contact', require('./components/filter/displayers/display-contact').default);
Vue.component('display-team', require('./components/filter/displayers/display-team').default);
Vue.component('display-team-time', require('./components/filter/displayers/display-team-time').default);
Vue.component('display-team-workload', require('./components/filter/displayers/display-team-workload').default);
Vue.component('display-team-taskstatus', require('./components/filter/displayers/display-team-taskstatus').default);
Vue.component('display-location', require('./components/filter/displayers/display-location').default);
Vue.component('display-date', require('./components/filter/displayers/display-date').default);
Vue.component('display-organisation', require('./components/filter/displayers/display-organisation').default);


Vue.component('reset-password', require('./components/user/reset-password').default);
Vue.component('user-icon', require('./components/user/user-icon').default);
Vue.component('user-detail-button', require('./components/user/user-detail-button').default);

Vue.component('user-selector', require('./components/user/user-selector').default);
Vue.component('invite-user-selector', require('./components/user/invite-user-selector').default);
Vue.component('invite-user', require('./components/user/invite-user').default);
Vue.component('invite-user-tab', require('./components/user/invite-user-tab').default);
Vue.component('invite-user-share', require('./components/user/invite-user-share').default);

Vue.component('contact-container', require('./components/contact/contact-container').default);
Vue.component('view-contact', require('./components/contact/view-contact').default);
Vue.component('contact-card', require('./components/contact/contact-card').default);

Vue.component('add-contact', require('./components/contact/add-contact').default);
Vue.component('contact-export-import', require('./components/contact/contact-export-import').default);


//
Vue.component('qr-invite-button', require('./components/qrcode/qr-invite-button').default);
Vue.component('qrcode-container', require('./components/qrcode/qrcode-container').default);
Vue.component('qrcode-logs', require('./components/qrcode/qrcode-logs').default);
Vue.component('view-qrcode', require('./components/qrcode/view-qrcode').default);
Vue.component('add-qrcode', require('./components/qrcode/add-qrcode').default);
Vue.component('qrcode-advanced-print', require('./components/qrcode/qrcode-advanced-print').default);


Vue.component('add-organisation', require('./components/organisation/add-organisation').default);
Vue.component('add-user-organisation', require('./components/organisation/add-user-organisation').default);
Vue.component('add-organisation-user', require('./components/user/add-organisation-user').default);

Vue.component('add-project', require('./components/project/add-project').default);
Vue.component('project-selector', require('./components/project/project-selector').default);

Vue.component('manage-sub-location', require('./components/location/manage-sub-location').default);
Vue.component('add-location', require('./components/location/add-location').default);
Vue.component('location-autocomplete', require('./components/location/location-autocomplete').default);

Vue.component('mobile-menu', require('./components/navigation/mobile-menu').default);
Vue.component('desktop-vertical-menu', require('./components/navigation/desktop-vertical-menu').default);
Vue.component('menu-item', require('./components/navigation/menu-item').default);

Vue.component('nux-desktop', require('./components/nux/nux-desktop').default);
Vue.component('nux-flow', require('./components/nux/nux-flow').default);
Vue.component('nux-flow2', require('./components/nux/nux-flow2').default);

/*Vue.component('user-list-schedule', require('./components/scheduling/user-list-schedule').default);*/
Vue.component('userlist-dropdown-schedule', require('./components/scheduling/userlist-dropdown-schedule').default);
Vue.component('create-schedule', require('./components/scheduling/create-schedule').default);
Vue.component('add-schedule-selector', require('./components/scheduling/add-schedule-selector').default);
Vue.component('user-schedule', require('./components/scheduling/user-schedule').default);

Vue.component('info-note', require('./components/notes/info-note').default);


//Chart stuff
Vue.component('simple-pie-chart', require('./components/charts/simple-pie-chart').default);
Vue.component('simple-line-chart', require('./components/charts/simple-line-chart').default);
Vue.component('simple-doughnut-chart', require('./components/charts/simple-doughnut-chart').default);

//Map stuff

// Object editor stuff
Vue.component('settingseditor-editmode', require('./components/settingseditor/settingseditor-editmode').default);
Vue.component('settingseditor-nested-property', require('./components/settingseditor/settingseditor-nested-property').default);

Vue.component('map-button', require('./components/maps/map-button').default);
Vue.component('gmaptest', require('./components/maps/gmaptest').default);
Vue.component('map-component', require('./components/maps/map-component').default);

// Report

Vue.component('add-report-schedule', require('./components/report/add-report-schedule').default);
Vue.component('admin-report-diagram-view', require('./components/report/admin-report-diagram-view').default);
Vue.component('report-diagram-view', require('./components/report/report-diagram-view').default);

// General setting
Vue.component('admin-general-setting', require('./components/general/admin-general-setting').default);

//Vue.component('googlemaploader', require('./components/maps/GoogleMapLoader').default);
//Vue.component('googlemapline', require('./components/maps/GoogleMapLine').default);
//Vue.component('googlemapmarker', require('./components/maps/GoogleMapMarker').default);
//Vue.component('travelmap', require('./components/maps/TravelMap').default);

//conditions
Vue.component('conditions-element', require('./components/conditions/conditions-element').default);
Vue.component('conditions-editor', require('./components/conditions/conditions-editor').default);
Vue.component('conditions-add', require('./components/conditions/conditions-add').default);
Vue.component('conditions-mail', require('./components/conditions/conditions-mail').default);
Vue.component('conditions-post', require('./components/conditions/conditions-post').default);

Vue.component('statistics-editor', require('./components/statistics/statistics-editor').default);
Vue.component('diagram-element', require('./components/statistics/diagram-element').default);
Vue.component('diagram-add', require('./components/statistics/diagram-add').default);
Vue.component('series-element', require('./components/statistics/series-element').default);
Vue.component('series-add', require('./components/statistics/series-add').default);


Vue.component('mail-editor-user', require('./components/mail/mail-editor-user').default);
Vue.component('mail-editor', require('./components/mail/mail-editor').default);
Vue.component('skin-editor', require('./components/skin-editor/skin-editor').default);

Vue.component('onboarding', require('./components/onboarding/onboarding').default);
Vue.component('onboarding-question', require('./components/onboarding/onboarding-question').default);
Vue.component('onboarding-answer', require('./components/onboarding/onboarding-answer').default);
Vue.component('onboarding-input', require('./components/onboarding/onboarding-input').default);
Vue.component('onboarding-qrblob', require('./components/onboarding/onboarding-qrblob').default);
Vue.component('onboarding-button', require('./components/onboarding/onboarding-button').default);
Vue.component('onboarding-qrcode', require('./components/onboarding/onboarding-qrcode').default);

Vue.component('help-left', require('./components/general/help-left').default);
Vue.component('help-right', require('./components/general/help-right').default);
Vue.component('help-bottom-left', require('./components/general/help-bottom-left').default);
Vue.component('help-bottom-right', require('./components/general/help-bottom-right').default);
Vue.component('help-icon', require('./components/general/help-icon').default);

Vue.component('flickr-button', require('./components/imagehandling/flickr-button').default);
Vue.component('pexels-button', require('./components/imagehandling/pexels-button').default);
Vue.component('dall-e-button', require('./components/imagehandling/dall-e-button').default);
Vue.component('image-card', require('./components/imagehandling/image-card').default);

// booking
Vue.component('add-resource', require('./components/booking/add-resource').default);
Vue.component('add-slot', require('./components/booking/add-slot').default);

//microservices
Vue.component('create-daily-list', require('./components/microservice/create-daily-list').default);
Vue.component('share-task-list', require('./components/microservice/share-task-list').default);
Vue.component('task-editmenu', require('./components/microservice/task-editmenu').default);

//ip-image

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBzWJ1qT3_CqQ5tBzUqJxGlsPkursfBb48',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'gmap-vue/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})



//Global config for scroller if we want.
/*
Vue.use(vuescroll, {
ops: {
  
  vuescroll: {
    mode: 'slide',
    zooming: false,
  },
  scrollPanel: {
    
  },
  rail: {
    background: '#F6F7F7',
    opacity: 0.5,
    size: '6px',
    specifyBorderRadius: false,
    gutterOfEnds: null,
    gutterOfSide: '2px',
    keepShow: false
  },
  bar: {
    onlyShowBarOnScroll: false,
    keepShow: true,
    background: '#666767',
  }
},
name: 'vue-scroll' // customize component name, default -> vueScroll
});
*/

Vue.use(VueLazyLoad)

Vue.use(Vuex)


Vue.directive('select', {
  twoWay: true,
  bind: function (el, binding, vnode) {
    $(el).select2().on("select2:select", (e) => {
      // v-model looks for
      //  - an event named "change"
      //  - a value with property path "$event.target.value"
      el.dispatchEvent(new Event('change', { target: e.target }));
    });
  },
});

var $eventBus = new Vue({ i18n});
window.$eventBus = $eventBus;

//Vue.use(VueAxios, axios);

Vue.prototype.$http = axios

//Global variables
Vue.prototype.$hostname = apiUrl;
Vue.prototype.$token = 'xyz'
Vue.prototype.$site = '0'

window.Vue = Vue;

interceptorsSetup();

/*
new Vue({
  el: '#app',
  render: h => h(App)
})
*/




// WEBPACK FOOTER //
// ./src/main.js